<div class="page">
    <div class="not-found-error">
        <h1>404</h1>
        <p>{{"generic.pageNotFound" | translate}} </p>
        <img class="company-logo" src="../../../../../assets/images/bosch_logo_800x189.png"/>
    </div>
</div>
